import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from '../../utilities';

import { Cell, Gulicka as GulickaEmpty } from './transfer';

const WrapperNoLeft = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${rem(1)};
`;

const Wrapper = styled(WrapperNoLeft) `
  margin-left: ${rem(5)};
`;

const GrayWrapper = styled(Wrapper) `
  color: ${({ theme }) => theme.color.font.secondary};
  border-left: ${rem(2)} dotted ${({ theme }) => theme.color.font.primary};
  padding-left: ${rem(24)};
  margin: 0;
  margin-left: ${rem(9)};
  font-size: ${rem(12)};
  margin-top: ${rem(4)};
`;

const BlackyWrapper = styled(GrayWrapper) `
  flex-direction: column-reverse;
  display: flex;
  align-items: baseline;
  color: ${({ theme }) => theme.color.font.primary};
  
  div{
    color: ${({ theme }) => theme.color.font.secondary};
    font-size: ${rem(14)};
  }
`;

const Prestup = styled.div`
  display: flex;
  align-items: baseline;
`;

const DiffTime = styled.div`
  color: ${({ theme }) => theme.color.font.secondary};
  font-size: ${rem(14)};
  margin-left: ${rem(5)};
`;

const Gulicka = styled.div`
  width: ${rem(10)};
  height: ${rem(10)};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.color.font.primary};
  margin-right: ${rem(22)};
`;

const Name = styled.span`
  font-size: ${rem(13)};
`;

const StopWrapper = styled.div`
  margin: ${rem(10)} 0;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  margin-left: -${rem(1)};
`;
const SCell = styled(Cell) `
  align-items: center;
`;

const StopDetail = props => {
  const {
    name,
    date,
    isLast,
    isFirst,
    sectorIndex,
    isLastSector,
    busChange,
    dateDiff,
    dateBusOut,
    dateBusIn,
    dateBusOutType,
    dateBusInType,
    dateType,
  } = props;
  const dateMoment = moment.parseZone(date);

  const momentDateIn = moment.parseZone(dateBusIn);
  const momentDateOut = moment.parseZone(dateBusOut);

  let content = <div />;
  if ((sectorIndex === 0 && isFirst) || isLast) {
    if (!isFirst && !isLastSector) {
      let stop = null;
      if (isLast) {
        stop = (
          <StopWrapper>
            <Wrapper>
              <Gulicka />
              <Name>{name}</Name>
            </Wrapper>
            <GrayWrapper>
              {`${dateMoment.format('D.M.YYYY')} | ${dateMoment.format(
                'HH:mm',
              )} | ${dateMoment.format('dddd')} | ${dateType}`}
            </GrayWrapper>
          </StopWrapper>
        );
      }
      return (
        <StopWrapper>
          {stop}
          <WrapperNoLeft
            style={{
              flexDirection: 'column',
              alignItems: 'unset',
            }}
          >
            <Flex style={{ marginLeft: 0 }}>
              <SCell>
                <GulickaEmpty />
                <Prestup>{__('Prestup')}
                  <DiffTime>{dateDiff && `(prestup trvá ${dateDiff})`}</DiffTime>
                </Prestup>
              </SCell>
            </Flex>
            <BlackyWrapper>
              <Prestup>
                {momentDateIn &&
                  `${momentDateIn.format('D.M.YYYY')} | ${momentDateIn.format(
                    'HH:mm',
                  )} | ${momentDateIn.format('dddd')} | ${dateBusInType}`}
                <br />
                {momentDateOut &&
                  `${momentDateOut.format('D.M.YYYY')} | ${momentDateOut.format(
                    'HH:mm',
                  )} | ${momentDateOut.format('dddd')} | ${dateBusOutType}`}
              </Prestup>
              <Name>{busChange}</Name>
            </BlackyWrapper>
          </WrapperNoLeft>
        </StopWrapper>
      );
    }
  }
  content = (
    <StopWrapper>
      <Wrapper>
        <Gulicka />
        <Name>{name}</Name>
      </Wrapper>
      <GrayWrapper>
        {`${dateMoment.format('D.M.YYYY')} | ${dateMoment.format(
          'HH:mm',
        )} | ${dateMoment.format('dddd')}  | ${dateType}`}
      </GrayWrapper>
    </StopWrapper>
  );

  return content;
};

StopDetail.propTypes = {
  name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  isLast: PropTypes.bool.isRequired,
  isFirst: PropTypes.bool.isRequired,
  sectorIndex: PropTypes.number.isRequired,
};

export default StopDetail;



// WEBPACK FOOTER //
// ./src/components/TravelRow/stopDetail.js